export default function SvgUserDeclineIcon(props) {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.7493 1.33331L17.916 5.49998M17.916 1.33331L13.7493 5.49998M13.3327 15.5V14.5C13.3327 13.0998 13.3327 12.3998 13.0602 11.865C12.8205 11.3946 12.4381 11.0121 11.9677 10.7725C11.4329 10.5 10.7328 10.5 9.33268 10.5H5.66602C4.26588 10.5 3.56582 10.5 3.03104 10.7725C2.56063 11.0121 2.17818 11.3946 1.9385 11.865C1.66602 12.3998 1.66602 13.0998 1.66602 14.5V15.5M10.416 4.24998C10.416 5.86081 9.11018 7.16665 7.49935 7.16665C5.88852 7.16665 4.58268 5.86081 4.58268 4.24998C4.58268 2.63915 5.88852 1.33331 7.49935 1.33331C9.11018 1.33331 10.416 2.63915 10.416 4.24998Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
